/**
 * Slack Token and Webhook patterns:
 *
 * Slack uses various types of tokens for authentication and webhooks for notifications.
 *
 * Patterns:
 * 1. Slack Bot Token:
 *    - Starts with 'xoxb-'
 *    - Followed by numeric and alphanumeric segments
 *
 * 2. Slack User Token:
 *    - Starts with 'xoxp-'
 *    - Followed by numeric and alphanumeric segments
 *
 * 3. Slack Workspace Token:
 *    - Starts with 'xoxa-'
 *    - Followed by numeric segments
 *
 * 4. Slack App-level Token:
 *    - Starts with 'xapp-'
 *    - Followed by numeric and alphanumeric segments
 *
 * 5. Slack Webhook URL:
 *    - Format: https://hooks.slack.com/services/T.../B.../...
 *    - Contains three segments of alphanumeric characters
 *
 * Examples:
 * - Bot Token: `xoxb-1234567890-1234567890123-abcdefghijklmnopqrstuvwx`
 * - User Token: `xoxp-1234567890-1234567890-1234567890-abcdef1234567890abcdef1234567890`
 * - Webhook: `https://hooks.slack.com/services/T00000000/B00000000/XXXXXXXXXXXXXXXXXXXXXXXX`
 *
 * References:
 * - https://github.com/secretlint/secretlint/blob/master/packages/%40secretlint/secretlint-rule-slack/src/index.ts
 * - https://api.slack.com/authentication/token-types
 * - https://api.slack.com/messaging/webhooks
 */

export const slackBotToken =
  /\bxoxb-[0-9]{10,13}-[0-9]{10,13}-[A-Za-z0-9]{24}\b/;
export const slackUserToken =
  /\bxoxp-[0-9]{10,13}-[0-9]{10,13}-[0-9]{10,13}-[A-Za-z0-9]{32}\b/;
export const slackWorkspaceToken = /\bxoxa-[0-9]+-[0-9]+-[0-9]+-[A-Za-z0-9]+\b/;
export const slackAppToken = /\bxapp-[0-9]+-[A-Z0-9]+-[0-9]+-[a-z0-9]+\b/i;
export const slackWebhook =
  /https:\/\/hooks\.slack\.com\/services\/T[A-Z0-9]+\/B[A-Z0-9]+\/[A-Za-z0-9]+/;
export const slackLegacyToken = /\bxoxo-[0-9]+-[0-9]+-[0-9]+-[A-Za-z0-9]+\b/;
